export default __webpack_public_path__ + "static/media/no-results.7c531ce0.webp";